@use "../../../styles/Colors.scss" as Colors;
@use "../../../styles/Constants.scss" as Constants;

.table-settings {
	&__item {
		display: flex;
		margin: Constants.$val-spacing-s 0;
		display: flex;
		align-items: center;

		&__label {
			color: Colors.$col-greyFontLight;
			margin-left: Constants.$val-spacing-m;
			font-style: italic;
		}
	}

	.icon-settings {
		cursor: pointer;
		color: Colors.$col-greyFontLight;

		&:focus,
		&:active,
		&:hover {
			color: Colors.$col-greyDark;
		}
	}
}